import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { storeRedirectUrl } from '../utils/sessionUtils';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const [user, setUser] = useState(null);
  const navigate = useNavigate();
  const Base_url = process.env.REACT_APP_BASE_URL;

  useEffect(() => {
    const storedState = localStorage.getItem('authState');
    if (storedState) {
      const { isAuthenticated, user } = JSON.parse(storedState);
      setUser(user);
      setIsAuthenticated(isAuthenticated);
    } else {
      //navigate("/login");
    }
  }, []);

  const login = async (data) => {
    try {
      const response = await axios.post(
        `${Base_url}/user/login`,
        {
          employeeId: data.username,
          password: data.password,
          applicationId: 'com.scnl.hcm.portal',
          appVersion: '21',
          loginMode: 'Desktop',
          grant_type: 'password',
        },
        {
          headers: {
            Authorization:
              'Basic YW1sYnZuMDllYzV4dXE3bDVnOXZ2YXJoMWs0eDYwaG06enQ0cGprd3BmeWwyZXZ4OXdnYXl5c254Ym1jcmpuZDg=',
          },
        }
      );
      console.log('login response', response);
      if (response.data) {
        setUser(response?.data?.data);
        setIsAuthenticated(true);
        localStorage.setItem(
          'authState',
          JSON.stringify({ isAuthenticated: true, user: response?.data?.data })
        );
        navigate('/');
        return;
      }
    } catch (error) {
      console.log('login error', error);
      setUser(error.response.data.message);
    }
  };

  const logout = () => {
    // Store the current URL before clearing data
    storeRedirectUrl();

    setIsAuthenticated(false);
    setUser(null);
    localStorage.clear();

    navigate('/login');
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
